import { adminApi } from './api';

export const getDiagnosticMainCategories = async () => {
  const response = await adminApi.get('/api/admin/diagnostic-training/main-categories');
  return response.data.data.sort((a, b) => a.mainCategoryId - b.mainCategoryId);
}

export const getDiagnosticSubCategories = async (mainCategoryId) => {
  const response = await adminApi.get(`/api/admin/diagnostic-training/main-categories/${mainCategoryId}`);
  return response.data.data;
}

/**
 * 진단 및 대응훈련 문제 목록 조회
 * @param {Object} params - page, size, languageId, problemId, level, isApproval, categoryId, subCategoryId
 * @param {string} [params.sort] - Spring Pageable 스타일 정렬 (현재 백엔드는 `problemId` 컬럼만 허용, 예: `problemId,asc`)
 */
export const getDiagnosticProblems = async (params) => {
  const response = await adminApi.get('/api/admin/diagnostic-training', { params });
  return response.data.data;
}

export const getDiagnosticProblemDetail = async (problemId) => {
  const response = await adminApi.get(`/api/admin/diagnostic-training/${problemId}`);
  return response.data.data;
}

export const createDiagnosticProblem = async (data) => {
  const response = await adminApi.post('/api/admin/diagnostic-training', data);
  return response.data.data;
}

export const updateDiagnosticProblem = async (problemId, data) => {
  const response = await adminApi.put(`/api/admin/diagnostic-training/${problemId}`, data);
  return response.data.data;
}

export const deleteDiagnosticProblem = async (problemId) => {
  const response = await adminApi.delete(`/api/admin/diagnostic-training/${problemId}`);
  return response.data.data;
}

export const updateProblemApproval = async (problemId, approval) => {
  const response = await adminApi.patch(`/api/admin/diagnostic-training/${problemId}/approval`, { approval });
  return response.data.data;
}

export const testStep1 = async (problemId, data) => {
  const response = await adminApi.post(`/api/admin/diagnostic-training/${problemId}/test/step1`, data);
  return response.data.data;
}

export const testStep2 = async (problemId, data) => {
  const response = await adminApi.post(`/api/admin/diagnostic-training/${problemId}/test/step2`, data);
  return response.data.data;
}